import { useEffect } from "preact/hooks";
/**
 * @format
 */
export const randomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
};

export const once = (fn, context) => {
  var result;

  return function () {
    if (fn) {
      result = fn.apply(context || this, arguments);
      fn = null;
    }

    return result;
  };
};

export const b64DecodeUnicode = (str) => {
  return decodeURIComponent(
    atob(str)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
};

export const parseQuestionResponse = (userInput) => {
  let inputString = userInput && userInput.replace(/\\\\/g, "\\");
  return convertStringToArray(inputString);
};

const useDetectOutSideClick = (ref, handler) => {
  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };

      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);

      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
};

export default useDetectOutSideClick;

export const insertDataInStaticString = (staticStr, dataArray) => {
  let convertedStr = staticStr;
  dataArray.forEach((dataElem, i) => {
    const rgx = new RegExp(`{replace_rgx_${i + 1}}`, "gm");
    convertedStr = convertedStr.replace(rgx, dataElem);
  });
  return convertedStr;
};

export const userNameSanitizer = /[^a-z0-9@áéíóúñü \.,_-]/gim;

export const sanitizeString = (str, regex = userNameSanitizer) => {
  str = str.replace(regex, "");
  return str.trim();
};

export const isPieChartEmpty = (data) => {
  return data.reduce((acc, i, index) => {
    return (acc = i[1] === 0 && true && acc);
  }, true);
};

export const checkNegativeYAxis = (data) => {
  return data.reduce((flag, i, index) => {
    if (index === 0) return true;
    return (flag = i[1] === 0 && true);
  }, true);
};

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export class DateConverter {
  //use DateConvertor.utcToLocal(utcString) to get local time formats from UTC ISO 8601
  static utcToLocal(utcString) {
    try {
      if (!utcString) {
        throw new Error("Invalid UTC string");
      }
      const formatMatches = utcString.match(
        /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?Z$/
      );
      if (!formatMatches) {
        throw new Error(
          "Invalid UTC format. Expected ISO 8601 format (YYYY-MM-DDTHH:mm:ssZ)"
        );
      }
      const [, yearStr, monthStr, dayStr, hoursStr, minutesStr, secondsStr] =
        formatMatches;
      const year = parseInt(yearStr, 10);
      const month = parseInt(monthStr, 10) - 1;
      const day = parseInt(dayStr, 10);
      const hours = parseInt(hoursStr, 10);
      const minutes = parseInt(minutesStr, 10);
      const seconds = parseInt(secondsStr, 10);
      if (
        month < 0 ||
        month > 11 ||
        day < 1 ||
        day > 31 ||
        hours < 0 ||
        hours > 23 ||
        minutes < 0 ||
        minutes > 59 ||
        seconds < 0 ||
        seconds > 59
      ) {
        throw new Error("Invalid date components");
      }
      const utcDate = new Date(
        Date.UTC(year, month, day, hours, minutes, seconds)
      );
      const localDate = {
        year: utcDate.getFullYear(),
        month: utcDate.getMonth() + 1,
        day: utcDate.getDate(),
        hours: utcDate.getHours(),
        minutes: utcDate.getMinutes(),
        seconds: utcDate.getSeconds(),
      };
      const formattedDate = `${monthNames[localDate.month - 1]} ${String(
        localDate.day
      ).padStart(2, "0")} ${localDate.year}`;
      const formattedTime = `${String(localDate.hours).padStart(
        2,
        "0"
      )}:${String(localDate.minutes).padStart(2, "0")}:${String(
        localDate.seconds
      ).padStart(2, "0")}`;

      return {
        ...localDate,
        formattedDate,
        formattedTime,
        fullFormatted: `${formattedDate}, ${formattedTime}`,
        timezoneOffset: utcDate.getTimezoneOffset(),
      };
    } catch (e) {
      throw new Error(`Date conversion failed: ${e.message}`);
    }
  }

  //use DateConvertor.getCurrentUTC() will give the current UTC ISO 8601 time
  static getCurrentUTC() {
    return new Date().toISOString();
  }
}

export const convertUTCToLocal = (utcString) => {
  try {
    return DateConverter.utcToLocal(utcString).fullFormatted;
  } catch (e) {
    // console.error(e);
    return utcString;
  }
};
